const ExpandableType = {
  COMPONENT: 'Component',
};

export default ExpandableType;
